// External Services
import { requestForToken } from '../firebase';
import { patchRequest } from '../services/api/base';
import { StoreUtils } from './util';
import mixpanel from 'mixpanel-browser';

export const clickToPrint = async (fileUrl: string) => {
  const newIframe = document.createElement('iframe');
  newIframe.width = '0';
  newIframe.height = '0';
  document.body.appendChild(newIframe);
  fetch(fileUrl)
    .then((response) => response.blob())
    .then((myBlob: Blob) => {
      const objectURL = URL.createObjectURL(myBlob);
      newIframe.src = '';
      newIframe.src = objectURL;
      URL.revokeObjectURL(objectURL);
    })
    .then(() => {
      window.setTimeout(function () {
        newIframe?.contentWindow?.focus();
        newIframe?.contentWindow?.print();
      }, 200);
    });
};

export const htmlToPrint = async (fileUrl: string) => {
  const printWindow = window.open(fileUrl, '_blank', 'height=400,width=600');
  window.onfocus = () => {
    // Close the print window when focus is returned to the parent page
    printWindow?.close();
  };
};

export const htmlToPrintV2 = async (fileUrl: string) => {
  const printIframe = document.createElement('iframe');

  printIframe.width = '0';

  printIframe.height = '0';

  printIframe.style.border = '0';

  document.body.appendChild(printIframe);

  try {
    const response = await fetch(fileUrl);

    if (!response.ok) {
      throw new Error(`Failed to fetch HTML: ${response.status}`);
    }

    const htmlBlob = await response.blob();

    const objectURL = URL.createObjectURL(htmlBlob);

    printIframe.onload = () => {
      printIframe.contentWindow?.focus();

      printIframe.contentWindow?.print();

      URL.revokeObjectURL(objectURL);
    };

    printIframe.src = objectURL;
  } catch (error) {
    printIframe.remove();

    console.error('Failed to print HTML:', error);
  }
};

export const clickToDownload = async (fileUrl: string) => {
  const link = document.createElement('a');
  link.href = fileUrl;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const clickToDownloadXML = async (fileUrl: string) => {
  try {
    const response = await fetch(fileUrl);
    const responseBlob = await response.blob();
    // Create a temporary URL for the blob
    const blobUrl = window.URL.createObjectURL(new Blob([responseBlob]));

    // Create an anchor element
    const link = document.createElement('a');
    link.href = blobUrl;

    const fileName = fileUrl.split('/').pop();

    // Set the download attribute to specify the file name
    link.download = fileName || '1Pharmacy';

    // Programmatically click the link to trigger the download
    link.click();

    // Clean up: revoke the temporary URL
    window.URL.revokeObjectURL(blobUrl);
  } catch (e) {
    console.log(e);
  }
};

export const downloadJsonFile = async (fileUrl: string, fileName?: string) => {
  try {
    const response = await fetch(fileUrl);
    const responseBlob = await response.blob();
    const blobUrl = window.URL.createObjectURL(new Blob([responseBlob]));

    const link = document.createElement('a');
    link.href = blobUrl;

    link.download = (fileName ? fileName : '1Pharmacy') + '.json';

    link.click();

    window.URL.revokeObjectURL(blobUrl);
  } catch (e) {
    console.log(e);
  }
};

// Amplitude
export const initAmplitude = () => {
  try {
    const { session: activeSession } = StoreUtils.getActiveSession();
    const mixpanelToken = process.env.REACT_APP_MIXPANEL_TOKEN;

    if (process.env.REACT_APP_TYPE === 'prod' && mixpanelToken) {
      console.log('✅ Initializing Mixpanel');

      mixpanel.init(mixpanelToken || '', {
        autocapture: true,
        // eslint-disable-next-line camelcase
        record_sessions_percent: 100,
      });

      mixpanel.identify(activeSession?.userData?.userId);

      mixpanel.people.set({
        userId: activeSession?.userData?.userId,
        name: activeSession?.userData?.name,
        phone: activeSession?.userData?.phone,
        company: activeSession?.userData?.company,
        cid: activeSession?.cid,
        platform: '1p-ros-web',
      });
    }
  } catch (error) {
    console.error('Amplitude Initialization Error', error);
  }
};

// Firebase
export const sendFCMTokenToServer = async () => {
  try {
    const userId = StoreUtils.getKeyFromActiveSession(['session-token']);
    if (userId) {
      const token = await requestForToken();
      if (token) {
        await patchRequest(`user/${userId}`, { webFcmToken: token });
        console.log('FCM token has been sent to server', token);
      }
    }
  } catch (error) {
    console.error('FCM token sent server error', error);
  }
};
